import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LuUser, LuUserPlus } from "react-icons/lu";
import { PiStack, PiShoppingCartSimpleBold } from "react-icons/pi";
import { BsBoxSeam, BsMinecartLoaded, BsTelephone } from "react-icons/bs";
import { AiOutlineFileProtect } from "react-icons/ai";
import { RxEnter, RxExit } from "react-icons/rx";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../hooks/useAppSelector";
import { eraseCookie } from "../../helpers/cookies";

interface PropType {
  show: boolean;
  activeStatus: (status: boolean) => void;
}

// class side extends Component<PropType, StateType> {
const SideMenu: React.FC<PropType> = (props) => {
  const { t, i18n } = useTranslation();
  const navigation = useNavigate()
  const isAuth = useAppSelector((state) => state.user.isAuth);
  const userState = useAppSelector((state) => state.user);

  const changeToEnglish = (e: any) => {
    e.stopPropagation();
    i18n.changeLanguage("en");
  };

  const changeToChinese = (e: any) => {
    e.stopPropagation();
    i18n.changeLanguage("cn");
  };

  const handleLogOut = () => {
    eraseCookie("authToken");
    // window.location.reload();
    navigation("/")
  };

  useEffect(() => {
    const sideNavigations = document.querySelectorAll(".side-navigation > li");
    sideNavigations.forEach((single) => {
      single.addEventListener("click", () => {
        props.activeStatus(false);
      });
    });
  }, []);

  return (
    <div className={`side-menu ${props.show ? "active" : ""}`}>
      <div className="profile-card text-center">
        {/*<div className="profile-card__image space-mb--10">*/}
        {/*  <img*/}
        {/*    src={process.env.PUBLIC_URL + "/assets/img/profile.png"}*/}
        {/*    className="img-fluid"*/}
        {/*    alt=""*/}
        {/*  />*/}
        {/*</div>*/}
        <div className="profile-card__content">
          <span className="mt-2 font-weight-500 h3 color-mint lh-1">
            {userState.fullname}
          </span>
          <span className="h6 mt-2">{userState.rank_Name}</span>
        </div>
      </div>
      <div className="side-navigation-wrapper space-mt--20">
        <ul className="side-navigation">
          {isAuth && (
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/register"}
                className="d-flex flex-nowrap align-items-center"
              >
                <span className="icon">
                  <LuUserPlus size="14px" />
                </span>
                <span>{t("register account")}</span>
              </Link>
            </li>
          )}
          <li>
            <Link
              to={process.env.PUBLIC_URL + "/profile"}
              className="d-flex flex-nowrap align-items-center"
            >
              <span className="icon">
                <LuUser />
              </span>
              <span>{t("my profile")}</span>
            </Link>
          </li>
          <li>
            <Link
              to={process.env.PUBLIC_URL + "/resource"}
              className="d-flex flex-nowrap align-items-center"
            >
              <span className="icon">
                <PiStack />
              </span>
              <span>{t("resource")}</span>
            </Link>
          </li>
          <li>
            <Link
              to={process.env.PUBLIC_URL + "/products/maintenance"}
              className="d-flex flex-nowrap align-items-center"
            >
              <span className="icon">
                <BsBoxSeam />
              </span>
              <span>{t("repeat purchase")}</span>
            </Link>
          </li>
          <li>
            <Link
              to={process.env.PUBLIC_URL + "/order"}
              className="d-flex flex-nowrap align-items-center"
            >
              <span className="icon">
                <BsMinecartLoaded />
              </span>
              <span>{t("my order")}</span>
            </Link>
          </li>
          <li>
            <Link
              to={process.env.PUBLIC_URL + "/cart"}
              className="d-flex flex-nowrap align-items-center"
            >
              <span className="icon">
                <PiShoppingCartSimpleBold />
              </span>
              <span>{t("cart")}</span>
            </Link>
          </li>
          <li>
            <Link
              to={process.env.PUBLIC_URL + "/policy"}
              className="d-flex flex-nowrap align-items-center"
            >
              <span className="icon">
                <AiOutlineFileProtect />
              </span>
              <span>{t("policy")}</span>
            </Link>
          </li>
          <li>
            <Link
              to={process.env.PUBLIC_URL + "/contactUs"}
              className="d-flex flex-nowrap align-items-center"
            >
              <span className="icon">
                <BsTelephone />
              </span>
              <span>{t("contact us")}</span>
            </Link>
          </li>
        </ul>
      </div>
      <div className="d-flex justify-content-between align-self-end mb-5">
        <div className="d-flex align-items-center">
          {userState.isAuth ? (
            <a onClick={handleLogOut}>
              <div className="fs-6">
                <RxExit className="logIcon me-2" />

                {t("log out")}
              </div>
            </a>
          ) : (
            <Link to={process.env.PUBLIC_URL + "/login"}>
              <RxEnter className="logIcon" />
              <span className="ms-2 fs-6">{t("Log In")}</span>
            </Link>
          )}
        </div>
        <span>
          <span onClick={changeToEnglish}>EN</span> |{" "}
          <span onClick={changeToChinese}>CN</span>
        </span>
      </div>
    </div>
  );
};

export default SideMenu;
